export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAILURE = "GET_DATA_FAILURE";

export const GET_RING_REQUEST = "GET_RING_REQUEST";
export const GET_RING_SUCCESS = "GET_RING_SUCCESS";
export const GET_RING_FAILURE = "GET_RING_FAILURE";

export const GET_BRACELET_REQUEST = "GET_BRACELET_REQUEST";
export const GET_BRACELET_SUCCESS = "GET_BRACELET_SUCCESS";
export const GET_BRACELET_FAILURE = "GET_BRACELET_FAILURE";

export const GET_MANGALSUTRA_REQUEST = "GET_MANGALSUTRA_REQUEST";
export const GET_MANGALSUTRA_SUCCESS = "GET_MANGALSUTRA_SUCCESS";
export const GET_MANGALSUTRA_FAILURE = "GET_MANGALSUTRA_FAILURE";